import React, { FC } from 'react';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FormFieldProps,
} from './form-elements';

export const StatementField: FC<FormFieldProps> = ({ field }) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <FormItemDesc label={field.description} />
    </FormItemWrapper>
  );
};
